import { Box } from '@mui/material';
import { Fragment } from 'react';

import { Skeleton } from '@/components';

import { EpisodeCardMediumDimensions } from '../../constants';
import { episodeCardStyles } from '../../styles';

interface EpisodeCardSkeletonProps {
  includeText?: boolean;
  stretch?: boolean;
}

export const EpisodeCardMediumSkeleton = ({
  includeText = false,
  stretch = false,
}: EpisodeCardSkeletonProps) => (
  <Box
    sx={
      stretch
        ? {
            width: '100%',
            aspectRatio: `${EpisodeCardMediumDimensions.coverImageWidth} / ${EpisodeCardMediumDimensions.coverImageHeight}`,
          }
        : {
            width: EpisodeCardMediumDimensions.width,
          }
    }>
    <Box
      sx={{
        width: stretch ? '100%' : EpisodeCardMediumDimensions.coverImageWidth,
        height: stretch ? '100%' : EpisodeCardMediumDimensions.coverImageHeight,
        mb: 1,
        borderRadius: episodeCardStyles.cover.borderRadius,
        overflow: 'hidden',
      }}>
      <Skeleton variant="rounded" />
    </Box>
    {includeText && (
      <Fragment>
        <Skeleton height={16} />
        <Skeleton width="80%" height={16} />
        <Skeleton width="80%" height={16} />
      </Fragment>
    )}
  </Box>
);
